var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mouse",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.125 1.07617V6.03242H12.5C12.5 3.48242 10.5938 1.38242 8.125 1.07617ZM2.5 9.78242C2.5 12.5449 4.7375 14.7824 7.5 14.7824C10.2625 14.7824 12.5 12.5449 12.5 9.78242V7.28242H2.5V9.78242ZM6.875 1.07617C4.40625 1.38242 2.5 3.48242 2.5 6.03242H6.875V1.07617Z",
    fill: "#323232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.0a113003023314e93e7792b679721f9f.svg";
export { ForwardRef as ReactComponent };